// MEMO: 最終的にGlobalなEventListenerを使うようにしたいが、一旦このhookの中でDocument.addEventListenerを使うようにする

import { useEffect } from 'react';
import type { RefObject } from 'react';

function useClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: MouseEvent) => void,
  active: boolean
): void {
  useEffect(() => {
    if (!active) {
      return undefined;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handler, active]);
}

export default useClickOutside;
